<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <div>
        <el-form-item label="订单号">
          <el-input
            v-model="formInline.orderid"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="订单名称">
        <el-input
          v-model="formInline.orderName"
          placeholder="请输入订单名称"
        ></el-input>
        </el-form-item>-->
        <el-form-item label="用户名">
          <el-input
            v-model="formInline.username"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机(尾号)">
          <el-input
            v-model="formInline.userMobile"
            placeholder="请输入手机"
          ></el-input>
        </el-form-item>
        <el-form-item label="机器号">
          <el-input
            v-model="formInline.machineid"
            placeholder="请输入机器号"
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="订单状态">
          <el-select v-model="formInline.orderStatus" placeholder="请选择">
            <el-option
              v-for="(item, index) in ORDER_STATUS_ENUM"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否支付">
          <el-select v-model="formInline.ispaid" placeholder="请选择">
            <el-option
              v-for="(item, index) in PAID_STATUS_ENUM"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预定日期">
          <el-date-picker
            v-model="formInline.orderDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div>
        <agentVendorShop @select="selectHandler" />

        <!-- <el-form-item label="所在城市">
          <el-select v-model="formInline.city" placeholder="请选择">
            <el-option
              v-for="(item, index) in CITY_ENUM"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="handleDownload"
            >下载</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="orderid" label="订单号"></el-table-column>
      <el-table-column prop="orderName" label="订单名称"></el-table-column>
      <el-table-column
        prop="totalPrice"
        label="金额"
        width="70px"
      ></el-table-column>
      <el-table-column prop="username" label="用户名">
        <template slot-scope="scope">
          <div v-html="scope.row.username"></div>
        </template>
      </el-table-column>
      <el-table-column prop="userMobile" label="手机号">
        <template slot-scope="scope">
          {{ scope.row.userMobile }}

          <el-button
            type="primary"
            plain
            size="mini"
            round
            @click="searchSameMobile(scope.row.userMobile)"
            >相关</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="machineid" label="机器id" width="150px">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'machine', query: { machineid: scope.row.machineid } }"
            >{{ scope.row.machineid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column label="加盟商名称">
        <template slot-scope="scope">
          <div>{{ scope.row.vendorid }}</div>
          <div>{{ $getVendorName(scope.row.vendorid) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="门店名称">
        <template slot-scope="scope">
          <div>{{ $getShopName(scope.row.shopid) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预定日期" width="100px">
        <template slot-scope="scope">
          <div>{{ scope.row.orderDate | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <div v-html="$formatOrderStatus(scope.row.orderStatus)"></div>
        </template>
      </el-table-column>
      <el-table-column label="是否支付">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" effect="dark" v-if="scope.row.ispaid"
              >已支付</el-tag
            >
            <el-tag type="info" effect="dark" v-else>未支付</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" width="100px">
        <template slot-scope="scope">
          <div>{{ scope.row.paidTime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="取消时间" width="100px">
        <template slot-scope="scope">
          <div>{{ scope.row.cancelTime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="operator" label="操作员"> </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetail(scope.$index)"
            >详情</el-button
          >
          <el-button type="text" @click="showPrinter(scope.row)"
            >打印</el-button
          >
          <el-button type="text" @click="directToNotifyMessage(scope.row)"
            >报文</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <DetailDialog
      v-if="showDetailDialog"
      :tableData="selectedOrderItem"
      @closeDialog="closeDialog"
    />

    <PrinterDialog
      v-if="showPrinterDialog"
      :orderData="printOrder"
      :shopName="printShopName"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";

import DetailDialog from "./components/detailDialog";
import PrinterDialog from "./components/printerDialog";
import enumObject from "../../plugins/enum";
import moment from "moment";

//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop,
    DetailDialog,
    PrinterDialog
  },
  data() {
    return {
      formInline: {
        orderid: "",
        orderName: "",
        username: "",
        userMobile: "",
        orderDate: "",
        orderStatus: null,
        ispaid: null,
        paidTime: "",
        cancelTime: "",
        operator: "",
        vendorid: "",
        vendorName: "",
        city: "",
        shopid: "",
        shopName: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 30
      },

      ORDER_STATUS_ENUM: enumObject.ORDER_STATUS_ENUM,
      PAID_STATUS_ENUM: enumObject.PAID_STATUS_ENUM,
      CITY_ENUM: enumObject.CITY_ENUM,
      showDetailDialog: false,
      showPrinterDialog: false,
      lstOrderItemList: [],
      selectedOrderItem: [],
      printOrder: null,
      printShopName: null,
      vendorListForPrompt: [],
      shopListForPrompt: []
    };
  },

  mounted() {
    if (this.$route.query.orderid) {
      this.formInline.orderid = this.$route.query.orderid;
    }
    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }
    this.getParams();
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        orderid: this.formInline.orderid,
        // orderName: this.formInline.orderName,
        username: this.formInline.username,
        userMobile: this.formInline.userMobile,
        machineid: this.formInline.machineid,
        orderDateFrom: Array.isArray(this.formInline.orderDate)
          ? this.$ToDateTimeString(this.formInline.orderDate[0])
          : null,
        orderDateTo: Array.isArray(this.formInline.orderDate)
          ? this.$ToDateTimeString(this.formInline.orderDate[1])
          : null,
        // paidTimeFrom: Array.isArray(this.formInline.paidTime)
        //   ? this.$ToDateString(this.formInline.paidTime[0])
        //   : null,
        // paidTimeTo: Array.isArray(this.formInline.paidTime)
        //   ? this.$ToDateString(this.formInline.paidTime[1])
        //   : null,
        // cancelTimeFrom: Array.isArray(this.formInline.cancelTime)
        //   ? this.$ToDateString(this.formInline.cancelTime[0])
        //   : null,
        // cancelTimeTo: Array.isArray(this.formInline.cancelTime)
        //   ? this.$ToDateString(this.formInline.cancelTime[1])
        //   : null,
        orderStatus: this.formInline.orderStatus,
        ispaid: this.formInline.ispaid,
        vendorid: this.formInline.vendorid,
        agentid:this.formInline.agentid,
        city: this.formInline.city,
        shopid: this.formInline.shopid,
        // operator: this.formInline.operator,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询订单"], {
        data: queryModel
      }).then(result => {
        let data = result.data;
        this.tableData = data.map(item => item.orderInfo);
        this.lstOrderItemList = data.map(item => item.lstOrderItem);
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },

    searchSameMobile(mobile) {
      this.formInline.userMobile = mobile;
      this.onSubmit();
    },

    onAdd() {},

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    showDetail(index) {
      this.selectedOrderItem = this.lstOrderItemList[index];
      this.showDetailDialog = true;
    },

    showPrinter(order) {
      this.printOrder = order;
      this.printShopName = this.$getShopName(order.shopid);
      this.showPrinterDialog = true;
    },

    directToNotifyMessage(row) {
      this.$router.push({
        name: "notifyMessage",
        query: {
          machineid: row.machineid,
          from: this.$ToDateTimeString(
            moment(row.paidTime).subtract(30, "minute")
          ),
          to: this.$ToDateTimeString(moment(row.paidTime).add(30, "minute"))
        }
      });
    },
    closeDialog() {
      this.selectedOrderItem = [];
      this.showDetailDialog = false;
      this.showPrinterDialog = false;
    },

    async getParams() {
      // 取到路由带过来的参数
      if (this.userType === "admin") {
        //await this.queryVendor();
        await this.$queryVendorForPrompt(null, result => {
          this.vendorListForPrompt = result;
        });
      } else if (this.userType === "vendor" || this.userType === "agent") {
        await this.$queryShopForPrompt(this.formInline.vendorid, result => {
          this.shopListForPrompt = result;
        });
      }

      const username = this.$route.query.username;
      if (username == "" || username == undefined) {
        this.onSubmit();
        return;
      }
      // 将数据放在当前组件的数据内
      this.formInline.username = username;
      this.onSubmit();
    },

    handleDownload() {
      let queryModel = {
        orderid: this.formInline.orderid,
        // orderName: this.formInline.orderName,
        username: this.formInline.username,
        userMobile: this.formInline.userMobile,
        machineid: this.formInline.machineid,
        orderDateFrom: Array.isArray(this.formInline.orderDate)
          ? this.$ToDateTimeString(this.formInline.orderDate[0])
          : null,
        orderDateTo: Array.isArray(this.formInline.orderDate)
          ? this.$ToDateTimeString(this.formInline.orderDate[1])
          : null,
        orderStatus: this.formInline.orderStatus,
        ispaid: this.formInline.ispaid,
        vendorid: this.formInline.vendorid,
        city: this.formInline.city,
        shopid: this.formInline.shopid,
        pageNum: 1,
        pageSize: 500000
      };

      let strUserInfo = localStorage.getItem("userInfo");
      if (!strUserInfo) {
        return;
      }
      let userInfo = JSON.parse(strUserInfo);

      if (userInfo.user_type == "vendor") {
        queryModel.vendorid = userInfo.vendorid;
      }

      if (queryModel.vendorid == "") {
        this.$notify.error({
          title: "错误",
          message: "必须输入加盟商信息"
        });
        return;
      }

      if (
        queryModel.orderDateTo == "" ||
        queryModel.orderDateTo == null ||
        queryModel.orderDateFrom == "" ||
        queryModel.orderDateFrom == null
      ) {
        this.$notify.error({
          title: "错误",
          message: "必须输入起止日期"
        });
        return;
      }

      this.$download(this.$urlMapping["下载订单"], {
        data: queryModel
      }).then(result => {
        console.log(result);

        this.downloadCSV(result.data);
      });
    },

    downloadCSV(url, fileName) {
      var blob = new Blob([url], {
        type: "application/octet-stream;charset=utf-8"
      }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download =
        typeof fileName !== "undefined"
          ? fileName + ".zip"
          : "订单" + moment().format("YYYYMMDDHHmmss") + ".zip"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}
</style>
